// @ts-ignore
import React from "react";

import {Box, Container, Divider, Flex, Heading, HStack, Link, Text, VStack} from "@chakra-ui/react";

import {Outlet} from "react-router-dom";
import {BackgroundImagePage} from "../Components/BackgroundImage";
import {TopBar} from "./TopBar";

function MainContent() {
    return (
        <Box flex="1" p={0}>
            <VStack alignItems="center" gap={4}>
                <Heading display='none'> Main Content Area </Heading>
                <Outlet/>
            </VStack>
        </Box>
    );
}

export const MainLayout = () => {
    return (
        <VStack spacing={0} mx={0} px={0} minH="100vh">
            <TopBar/>
            <Divider borderColor="gray.300" m={0}/>
            <BackgroundImagePage>
                <Container maxW="6xl" pt={{ base: 10, md: 14 }} pb={{ base: 10, md: 14 }}>
                    <MainContent/>
                </Container>
            </BackgroundImagePage>
            <Divider borderColor="gray.200" m={0}/>
            <Box w="full" bg="white" borderTopWidth="1px" borderTopColor="gray.100">
                <Container maxW="6xl" py={10}>
                    <Flex direction={{base: 'column', md: 'row'}} justify="space-between" align={{base: 'flex-start', md: 'center'}} gap={6}>
                        <HStack spacing={4}>
                            <Link href="https://glacio.tech/about" color="gray.600" _hover={{color: 'blue.600'}} isExternal>
                                About
                            </Link>
                            <Link href="https://glacio.tech/contact" color="gray.600" _hover={{color: 'blue.600'}} isExternal>
                                Contact Us
                            </Link>
                        </HStack>
                        <Text color="gray.500" fontSize="sm">&copy; {new Date().getFullYear()} Glacio</Text>
                    </Flex>
                </Container>
            </Box>
        </VStack>
    )
}